import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NodeViewWrapper = _resolveComponent("NodeViewWrapper");
    return (_openBlock(), _createBlock(_component_NodeViewWrapper, {
        as: "span",
        class: "mention",
        "data-mention-participant-id": _ctx.dataMentionParticipantId,
        "data-mention-id": _ctx.dataMentionId
    }, {
        default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.mappedValue), 1)
        ]),
        _: 1
    }, 8, ["data-mention-participant-id", "data-mention-id"]));
}
